// extracted by mini-css-extract-plugin
export default {"tippy-box":"icon_tippy-box__Hs4UK","icon":"icon_icon__2n+L8","half":"icon_half__F8pU2"};